export default __webpack_public_path__ + "static/portfolio-case-study-3d4cd055a1aa2ff5c14000fb76d7bbf4.jpg";